import React from 'react';
import ShowTradedCheckbox from './showTraded';
import { getBidPopupText, groupItemsBy, getSingleItem } from '../services/utils';
import SelectUser from './selectUser';
const TPU = require('../../../backend/utils/tradingPeriod_utils');
const { getTradingPeriodBegin, getTradingPeriodEnd } = TPU;

class BidPopup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            accepted_by_behalf_of_id: '',
            show_traded: false,
            submitCliked: false
        }

        this.is_behalf_fetched = false;
        this.refreshBehalfUsers = this.refreshBehalfUsers.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    
    componentDidMount() {
        this.refreshBehalfUsers();
    }

    refreshBehalfUsers() {
        let { currentUser, visible, formData } = this.props;

        if ((currentUser.isSuperUser || currentUser.isAdmin) && visible && !this.is_behalf_fetched
            && formData.creator_company_id && formData.market_id) {
            this.is_behalf_fetched = true;
            this.props.getBehalfUsers({
                company_id: formData.creator_company_id,
                market_id: formData.market_id,
                product_id: formData.product_id
            });
        }
    }

    closePopup(e) {
        if (e.target.getAttribute('name') == 'bidPopup') {
            this.props.hidePopup();
        }
    }

    handleChange(e) {
        const name = e.target.name,
        type = e.target.type,
        value = type === 'checkbox' ? e.target.checked : e.target.value;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(popupTextAfterParams) {
        let requestData = {}, isValid = false,
        { formData, currentUser } = this.props,
        isSuperUser = currentUser.isSuperUser || currentUser.isAdmin,
        tradingPeriodBegin = getTradingPeriodBegin(formData.trading_period_prefix, formData.trading_period),
        tradingPeriodEnd = getTradingPeriodEnd(formData.trading_period_prefix, formData.trading_period),
        isCME = formData.contract_type === 'CME',
        now = new Date();

        this.setState({
            submitCliked: true
        });

        requestData = {
            id: formData.id,
            price: formData.price,
            quantity: formData.quantity,
            accepted_by_behalf_of_id: isSuperUser ? this.state.accepted_by_behalf_of_id : null,
            accepted_by_id: currentUser.id,
            show_traded: isSuperUser ? this.state.show_traded : true
        }
        isValid = isSuperUser ? this.state.accepted_by_behalf_of_id : true;

        if (isValid) {
            if (tradingPeriodEnd !== null && now >= tradingPeriodEnd) {
                this.props.showPopup({
                    title: 'Error',
                    content: 'You cannot place an order in the past',
                    buttonText: 'Close',
                });
            } else {
                let title = 'ORDER RECEIVED!';
                if(isCME) {
                    title = 'YOUR ORDER HAS BEEN RECEIVED';
                }
                this.props.updateBid(title, requestData, popupTextAfterParams);
            }
        }
    }

    renderPopupBody() {
        let { behalfUsers, behalfUsersExtra, formData, currentUser, popupTextAfter } = this.props;

        let isValid = this.state.accepted_by_behalf_of_id ? true : false,
        isSuperUser = currentUser.isSuperUser || currentUser.isAdmin,
        isPhysical = formData.contract_type === 'Physical';

        const products = currentUser.userInfo.products

        if (products === undefined) {
            return // we are logout.
        }

        const product = getSingleItem(formData.product_id, currentUser.userInfo.products);
        formData.allFreights = this.props.freights;
        formData.freights = product.freights;
        
        const popupTextBefore = getBidPopupText(formData, currentUser.userInfo, behalfUsers, behalfUsersExtra);
        const popupTextAfterParams = [formData, currentUser.userInfo, behalfUsers, behalfUsersExtra, 'success'];

        let selectedObject;
        const behalfUsersGroups = groupItemsBy(behalfUsers, 'companyname');
        const behalfUsersOptions = Object.entries(behalfUsersGroups).map(group => {
            return { 
                label: group[0],
                options: group[1].map(item => {
                    if (item.id === this.state.accepted_by_behalf_of_id) {
                        selectedObject = { label: item.username, value: item.id };
                    }
                    return { label: item.username, value: item.id, company: group[0] };
                })
            }
        });

        return (
            <div className='worklog-place-accept'>
                <center><h1 className='popup-title'>Please confirm the following:</h1></center>
                <div className='popup-content'>{ popupTextBefore }</div>
                <div className='bid-input'>
                  { isSuperUser ?
                  <div className='field-wrap'>
                    <label htmlFor='intent' className={'labelactive '+(!isValid && this.state.submitCliked ? 'error' : '')}>
                      Select client
                    </label>
                    <SelectUser 
                        groupedOptions={behalfUsersOptions} 
                        onChange={(selected) => this.setState({accepted_by_behalf_of_id: selected.value})}
                        selectedValue={selectedObject}
                    />
                  </div>
                  : null }
                  { isSuperUser ?
                      <ShowTradedCheckbox value={this.state.show_traded} onChange={this.handleChange} />
                  : null }
                  <div className='popup-buttons'>
                        <div className='multi-column-row'>
                            <div className='column'>
                                <button onClick={() => this.handleSubmit(popupTextAfterParams)} className='button button-block'>Yes</button>
                            </div>
                            <div className='column'>
                                <button
                                    onClick={this.props.hidePopup}
                                    className='button button-block'>No</button>
                            </div>
                        </div>
                  </div>
                  { isSuperUser ?
                    <div className='last-edit-user'>
                        <br/>
                        Last edited by {formData.last_edit_user}
                    </div>
                  : null }
                </div>
            </div>
        );

    }

	render() {
        return (
            <div name='bidPopup' className='-place-bid-container generic-popup-container'
                onClick={ this.closePopup.bind(this) }
                style={{display: this.props.visible ? 'block' : 'none' }}>

                { this.renderPopupBody() }

            </div>
        )
    }
}

export default BidPopup;



// WEBPACK FOOTER //
// ./source/components/bidPopup.js